<!-- @format -->

@for (mobilityPeriod of mobilityPeriods; track mobilityPeriod) {
  <div>
    <sis-basic-grouping-panel
      [attr.data-cy]="'mobility-period-panel'"
      [level]="6"
      [heading]="(mobilityPeriod.mobilityTypeUrn | codeLocalizedName | async) + ' ' + (mobilityPeriod.activityPeriod | localDateRange)">
      @if (mobilityPeriod.isCancelled) {
        <sis-tiny-badge variant="danger" class="header-badge">
          {{ "FLOW_STATE.CANCELLED" | translate }}
        </sis-tiny-badge>
      }
      <sis-description-list [columnCount]="1">
        <dl>
          @if (mobilityPeriod.mobilityDirection === "OUTBOUND") {
            <ng-template #listItem>
              <dt class="sis-label">{{ "MOBILITY_PERIOD.OUTBOUND_STUDENT.PHASE" | translate }}</dt>
              @if (mobilityPeriod.phase === "PHASE1") {
                <dd>{{ education.structure.phase1?.name | localizedString }}</dd>
              }
              @if (mobilityPeriod.phase === "PHASE2") {
                <dd>{{ education.structure.phase2?.name | localizedString }}</dd>
              }
            </ng-template>
          }
          @if (mobilityPeriod.mobilityDirection === "INBOUND") {
            <ng-template #listItem>
              <dt class="sis-label">{{ "MOBILITY_PERIOD.INBOUND_STUDENT.PHASE" | translate }}</dt>
              <dd>{{ mobilityPeriod.mobilityStudyRightTypeUrn | codeLocalizedName | async }}</dd>
            </ng-template>
          }
          <ng-template #listItem>
            <dt class="sis-label">{{ "MOBILITY_PERIOD.MOBILITY_PROGRAM" | translate }}</dt>
            <dd>
              {{ mobilityPeriod.mobilityProgramUrn | codeLocalizedName | async }}
              @if (mobilityPeriod.mobilityProgramDescription) {
                <ng-container>, {{ mobilityPeriod.mobilityProgramDescription }}</ng-container>
              }
            </dd>
          </ng-template>
          <ng-template #listItem>
            <dt class="sis-label" translate>
              {{
                "MOBILITY_PERIOD." + (mobilityPeriod.mobilityDirection === "OUTBOUND" ? "OUT" : "IN") + "BOUND_STUDENT.DESTINATION_COUNTRY"
              }}
            </dt>
            <dd>{{ mobilityPeriod.countryUrn | codeLocalizedName | async }}</dd>
          </ng-template>
          <ng-template #listItem>
            <dt class="sis-label">{{ "MOBILITY_PERIOD.ORGANISATION" | translate }}</dt>
            @if (mobilityPeriod.internationalInstitutionUrn) {
              <dd>
                {{ mobilityPeriod.internationalInstitutionUrn | codeLocalizedName | async }}
              </dd>
            }
            @if (!mobilityPeriod.internationalInstitutionUrn) {
              <dd>{{ mobilityPeriod.organisation }}</dd>
            }
          </ng-template>
          @if (mobilityPeriod.virtualMobilityType) {
            <ng-template #listItem>
              <dt class="sis-label">{{ "MOBILITY_PERIOD.VIRTUAL_EXCHANGE_TITLE" | translate }}</dt>
              <dd data-cy="mobility-period-virtual-mobility-type">
                {{ "MOBILITY_PERIOD.VIRTUAL_EXCHANGE_" + mobilityPeriod.virtualMobilityType.toUpperCase() | translate }}
              </dd>
            </ng-template>
          }
        </dl>
      </sis-description-list>
    </sis-basic-grouping-panel>
  </div>
}

@if (!mobilityPeriods.length) {
  <div class="sis-guidance">{{ "MOBILITY_PERIOD.NO_PRIOR_MOBILITY_INFO" | translate }}</div>
}
